import { styled } from '@mui/system';
import { Button } from '../Button/Button';
import { ButtonPropTypes } from '../Button/Button.types';
import CustomAvatar from '../CustomAvatar';
import { ColorHelperArgs } from './PostDiscussionMagnet.types';

function getTextAlignment({ variant }: ColorHelperArgs) {
  if (variant === 'inputAlike') {
    return 'start';
  }
  if (variant === 'contained') {
    return null;
  }
  return null;
}

function getBackgroundColor({ theme, variant }: ColorHelperArgs) {
  if (variant === 'inputAlike') {
    return theme.palette.common.white;
  }
  if (variant === 'contained') {
    return null;
  }
  return null;
}

function getFontColor({ theme, variant }: ColorHelperArgs) {
  if (variant === 'inputAlike') {
    return theme.palette.grey[400];
  }
  if (variant === 'contained') {
    return theme.palette.grey[50];
  }
  return theme.palette.grey[50];
}

export const Wrapper = styled('div')<{
  noPadding?: boolean;
  bgColor?: string;
  newUI?: boolean;
}>`
  padding: ${({ theme, noPadding, newUI }) =>
    !noPadding
      ? theme.spacing(newUI ? 6 : 5)
      : theme.spacing(newUI ? 6 : 5, 0)};
  background-color: ${({ theme, bgColor }) =>
    bgColor ?? theme.palette.grey[100]};
  width: 100%;
  border-radius: ${({ theme }) => theme.spacing(5)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  @media screen and (min-width: 640px) {
    gap: ${({ theme }) => theme.spacing(6)};
    padding: ${({ theme, noPadding, newUI }) => {
      const valV = newUI ? 5 : 8;
      const valH = newUI ? 6 : 8;
      return !noPadding ? theme.spacing(valV, valH) : theme.spacing(valV, 0);
    }};
  }
`;

const newUIInputHeight = 11.5;
export const InputButton = styled(Button)<
  Omit<ButtonPropTypes, 'variant'> & ColorHelperArgs & { newUI?: boolean }
>`
  font-weight: normal;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  padding: ${({ theme, newUI }) => theme.spacing(newUI ? 2 : 4, 4)};
  color: ${getFontColor};
  background-color: ${getBackgroundColor};
  line-height: 1;
  border-radius: ${({ theme, newUI }) => theme.spacing(newUI ? 6 : 4)};
  text-align: ${getTextAlignment};
  border: ${({ theme, newUI }) =>
    newUI ? `2px solid ${theme.palette.grey[100]}` : 'unset'};

  ${({ theme }) => theme.breakpoints.up('xs')} {
    font-size: ${({ theme, newUI }) => theme.spacing(newUI ? 4.5 : 4)};
    height: ${({ theme, newUI }) =>
      theme.spacing(newUI ? newUIInputHeight : 12)};
    min-height: ${({ theme, newUI }) =>
      theme.spacing(newUI ? newUIInputHeight : 12)};
    max-height: ${({ theme, newUI }) =>
      theme.spacing(newUI ? newUIInputHeight : 12)};
  }
  ${({ theme }) => theme.breakpoints.up('sm')} {
    font-size: ${({ theme, newUI }) => theme.spacing(newUI ? 4.5 : 5)};
    height: ${({ theme, newUI }) =>
      theme.spacing(newUI ? newUIInputHeight : 15)};
    min-height: ${({ theme, newUI }) =>
      theme.spacing(newUI ? newUIInputHeight : 15)};
    max-height: ${({ theme, newUI }) =>
      theme.spacing(newUI ? newUIInputHeight : 15)};
  }
`;

export const PostAvatar = styled(CustomAvatar)`
  flex-shrink: 0;
`;
